export default __webpack_public_path__ + "static/media/prada3.7578769f.jpg";